import { render } from "./projectsTMS.vue?vue&type=template&id=69c6d375"
import script from "./projectsTMS.vue?vue&type=script&lang=js"
export * from "./projectsTMS.vue?vue&type=script&lang=js"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__